import { ExpenseSummary } from '../store/expenses/expenses.types'
import {
  CarrierInvoice,
  InvoiceResponse,
  TransformInvoiceResponse,
} from '../store/invoices/invoices.types'

const escapeCsvCell = (value: string | number) =>
  `"${String(value).replace(/"/g, '""')}"`

const todayStamp = () => new Date().toISOString().split('T')[0]

const csvDate = (value?: string | null) => {
  if (!value) return ''
  if (/^\d{4}-\d{2}-\d{2}/.test(value)) return value.slice(0, 10)
  return value
}

const downloadCSV = (
  filename: string,
  headers: string[],
  rows: Array<Array<string | number>>
): void => {
  const csvContent = [
    headers.map(escapeCsvCell).join(','),
    ...rows.map((row) => row.map(escapeCsvCell).join(',')),
  ].join('\n')

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)

  link.setAttribute('href', url)
  link.setAttribute('download', filename)
  link.style.visibility = 'hidden'

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  URL.revokeObjectURL(url)
}

export const exportInvoicesToCSV = (
  invoices: TransformInvoiceResponse[],
  selectedInvoiceIds: Set<string>
): void => {
  const selectedInvoices: InvoiceResponse[] = []

  invoices.forEach((invoice) => {
    invoice.invoiceData.forEach((item) => {
      if (selectedInvoiceIds.has(item.id)) {
        selectedInvoices.push(item)
      }
    })
  })

  if (selectedInvoices.length === 0) {
    return
  }

  const headers = ['Order#', 'Load#', 'Company', 'Amount']
  const rows = selectedInvoices.map((invoice) => [
    invoice.userInvoiceId || '',
    invoice.loadNumber || '',
    invoice.customerName || '',
    invoice.totalAmount?.toFixed(2) || '0.00',
  ])

  downloadCSV(`invoices_${todayStamp()}.csv`, headers, rows)
}

export const exportVendorPayablesToCSV = (
  expenses: ExpenseSummary[],
  selectedIds: Set<string>
): void => {
  const selected = expenses.filter((expense) => selectedIds.has(expense.id))
  if (selected.length === 0) return

  const headers = ['Invoice#', 'Vendor', 'Invoice Date', 'Due Date', 'Amount']
  const rows = selected.map((expense) => [
    expense.invoiceNumber || '',
    expense.name || '',
    csvDate(expense.invoiceDate),
    csvDate(expense.dueDate),
    (expense.totalAmount ?? 0).toFixed(2),
  ])

  downloadCSV(`vendor_payables_${todayStamp()}.csv`, headers, rows)
}

export const exportCarrierPayablesToCSV = (
  invoices: CarrierInvoice[],
  selectedIds: Set<string>
): void => {
  const selected = invoices.filter((invoice) => selectedIds.has(invoice.id))
  if (selected.length === 0) return

  const headers = ['Load#', 'Order#', 'Carrier', 'Amount']
  const rows = selected.map((invoice) => [
    invoice.loadNumber || '',
    invoice.sourceUserOrderId || '',
    invoice.carrierName || '',
    invoice.totalAmount?.toFixed(2) || '0.00',
  ])

  downloadCSV(`carrier_payables_${todayStamp()}.csv`, headers, rows)
}
